module.exports = __webpack_public_path__ + "static/media/learnlocker.2710a565.png";